import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import { IAM_TENANT_SLUG } from "@/core/config";

const DEMO_TENANTS = new Set(["demo-hospitol"]);

export function isDemoHospitolTenant(): boolean {
  const slug =
    loadStoredSession()?.tenant?.slug?.trim().toLowerCase() ??
    IAM_TENANT_SLUG.trim().toLowerCase();

  return DEMO_TENANTS.has(slug);
}

export function shouldAutoSeedDemoData(): boolean {
  return isDemoModeEnabled();
}

/**
 * Active les seeds auto et l'UI démo (guide pharmacie, parcours [DÉMO-RX-*]).
 * Forcer : VITE_DEMO_MODE=true | désactiver : VITE_DEMO_MODE=false
 * Par défaut : dev local, ou build prod avec VITE_IAM_TENANT_SLUG=demo-hospitol.
 */
export function isDemoModeEnabled(): boolean {
  if (!isDemoHospitolTenant()) return false;

  const flag = import.meta.env.VITE_DEMO_MODE?.trim().toLowerCase();
  if (flag === "false" || flag === "0") return false;
  if (flag === "true" || flag === "1") return true;

  if (import.meta.env.DEV) return true;

  const buildTenant = import.meta.env.VITE_IAM_TENANT_SLUG?.trim().toLowerCase();
  return buildTenant === "demo-hospitol";
}
